<!-- =========================================================================================
    File Name: VerticalNavMenuItem.vue
    Description: Vertical NavMenu item component. Extends vuesax framework's 'vs-sidebar-item' component
    Component Name: VerticalNavMenuItem
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div
    class="vs-sidebar--item"
    :style="{zIndex: zIndex}"
    :class="{
      'vs-sidebar-item-active' : activeLink,
      disabled: menuItem.disabled,
      }"
  >
<!--:target="target" -->
<!--    exact 删除掉不包含-->
      <router-link
        exact
        tabindex="-1"
        v-if="!isURL(menuItem.url)"
        :class="{'router-link-active': activeLink}"
        :to="itemToRouterName"
      >
<!--        -->
<!--          <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />-->
<!--          <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />-->
            <icon-svg
              :icon-class="menuItem.icon || 'circle-XS'"
              class="icon-el"
              :class="{on: activeLink}"
            />
<!--            <i
              class="icon-el"
              :class="{
                [menuItem.icon]: menuItem.icon ? true: false,
                on: activeLink}"
            ></i>-->
          <slot />
      </router-link>
<!--      跳转外链-->
      <a v-else target="_blank" :href="menuItem.meta.iframeUrl" tabindex="-1">
<!--        <vs-icon v-if="!featherIcon" :icon-pack="iconPack" :icon="icon" />-->
<!--        <feather-icon v-else :class="{'w-3 h-3': iconSmall}" :icon="icon" />-->
        <icon-svg
          :icon-class="menuItem.icon || 'circle-XS'"
          class="icon-el"
          :class="{on: activeLink}"
        />
<!--        <i
          class="icon-el"
          :class="{
            [menuItem.icon]: menuItem.icon ? true: false,
            on: activeLink,
          }"
        ></i>-->
        <slot />
      </a>
  </div>
</template>

<script>
import { queryPublicAccountList } from '@/api/user'
import { isURL } from '@/utils/validate'
export default {
  name: 'v-nav-menu-item',
  props: {
    icon        : { type: String,                 default: ""               },
    iconSmall   : { type: Boolean,                default: false            },
    iconPack    : { type: String,                 default: 'material-icons' },
    href        : { type: [String, null],         default: '#'              },
    to          : { type: [String, Object, null], default: null             },
    featherIcon : { type: Boolean,                default: true             },
    zIndex: { },
    menuItem:{
      type: Object,
      default(){
        return {
          url: ''
        }
      }
    }
  },
  computed: {
    activeLink() {
      // 存入资金模块
      if(this.menuItem.url == 'depositFunds' && (this.$route.name == 'onlinePayDetail' || this.$route.name == 'digitalCashPayDetail' || this.$route.name == 'walletPayDetail' || this.$route.name == 'successSubmit' || this.$route.name == 'telegraphicPayDetail')){
        return true;
      }
      // 取出资金模块
      if(this.menuItem.url == 'withdraw' && (this.$route.name == 'withdrawDetail' || this.$route.name == 'successWithdrawSubmit')){
        return true;
      }
      // 交易报告
      if(this.menuItem.url == 'traderReport' && (this.$route.name == 'positionOrder' || this.$route.name == 'pendingOrder' || this.$route.name == 'traderHistory' )){
        return true;
      }

      //  我的客户
      if(this.menuItem.url == 'myCustomer' && (this.$route.name == 'report_custom' || this.$route.name == 'report_subIb' || this.$route.name == 'accountList' )){
        return true;
      }

      // 返佣统计
      if(this.menuItem.url == 'commissionManage' && (this.$route.name == 'commissionRecord' || this.$route.name == 'commissionOutRecord')){
        return true;
      }
      // 业绩统计 下的直客路由页面和子IB路由页面
      if(this.menuItem.url == 'performanceStatistics' && (this.$route.name == 'subIbPerformanceStatistics' || this.$route.name == 'customerPerformanceStatistics')){
        return true;
      }
      // 公告消息下的公告页面和系统消息由页面
      if(this.menuItem.url == 'message' && (this.$route.name == 'notice' || this.$route.name == 'messageSite')){
        return true;
      }
      if(this.menuItem.url == 'integralShop' && this.$route.name == 'productDetail'){
        return true;
      }
      // 积分明细
      if(this.menuItem.url == 'integralHome' && (this.$route.name == 'integralRecord')){
        return true;
      }
      // copyMaster MAM master详情 和MAM sub详情
      if(this.menuItem.url == 'copyMaster' && (this.$route.path.includes('mamMasterDetails')  || this.$route.path.includes('mamSubDetails'))){
        // todo 还要调整
        return true;
      }

      if(this.menuItem.url == 'bonusList' && (this.$route.name == 'doLot')){
        return true;
      }
      if(!this.menuItem.url){
        return false;
      }
      // console.log(this.menuItem,this.$route.name);

      return this.menuItem.url.replace('/', '-') === this.$route.name;
    },
    itemToRouterName(){
      if(!this.menuItem.url) return '';

      return { name: this.menuItem.url && this.menuItem.url.replace('/', '-') };
    }
  },
  mounted(){
  },
  methods: {
    isURL,
  },
}

</script>
<style lang="scss" scoped>
  .vs-sidebar--item {
    position: relative;
    &.disabled {
      // 禁用 todo
      opacity: 0.5;
      pointer-events: none;
    }
    .icon-el {
      margin-right: 10px;
      &.on {
        color: #fff;
      }
    }
  }

</style>
<style lang="scss" scoped>
  .icon-el {
    font-size: 20px;
    max-height: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /*width: 20px;
    height: 20px; */
    // 跟vuexy-vuejs-html-laravel-dashboard-admin-template一样,
  }
</style>
